import { render, staticRenderFns } from "./enquirylist.vue?vue&type=template&id=797ccec8&scoped=true"
import script from "./enquirylist.vue?vue&type=script&lang=js"
export * from "./enquirylist.vue?vue&type=script&lang=js"
import style0 from "./enquirylist.vue?vue&type=style&index=0&id=797ccec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ccec8",
  null
  
)

export default component.exports